import { Navigate, Route, Routes } from 'react-router';
import { Policies } from './pages/policies';
import { RefundRequest } from './pages/refund-request';
import { Subsidy } from '.';

export const SybsidyRoutes = () => {
  return (
    <Routes>
      <Route index element={<Subsidy />} />
      <Route path="novo" element={<RefundRequest key="novo" />} />
      <Route
        path="solicitacao/:id"
        element={<RefundRequest key="solicitacao" />}
      />
      <Route
        path="solicitacao/:id/pedido/:refund_request_uuid"
        element={<RefundRequest key="pedido" />}
      />
      <Route path="minhas-politicas" element={<Policies />} />
      <Route path="*" element={<Navigate to="/meus-reembolsos" replace />} />
    </Routes>
  );
};
